// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"195":"32efeb8b","361":"a97cf507","586":"ab575a04","656":"1a0a0593","674":"0bab8375","736":"778964ed"}[chunkId] + ".chunk.css";
};